import React from 'react';
import { render } from 'react-dom';
import { Provider } from 'react-redux';
require('formdata-polyfill');

import configureStore from './store';
import App from './containers/App';

/**
 * Minifig builder entry point
 *
 * @author John Noel <john.noel@joipolloi.com>
 * @package Minifigs
 */

const store = configureStore(window.__INITIAL_STATE__);

render(
    <Provider store={store}>
        <App />
    </Provider>,
    document.getElementById('app')
);
